<template>
  <div>
    <div v-if="!user"> 
      <portal-login @ajuda="registrar_ajuda" @configs="registrar_configs" @particular="definir_particular" />
      <Login v-if="1 == 0"/>
    </div>
    <div class="p-grid" style="position:relative; min-height:100vh; margin: 0em;" v-else>

      <div class="p-col-12" :class="containerClass" @click="onWrapperClick">
        <PortalTopBar :link_ajuda="link_ajuda" />

        <div class="layout-main vertical-container mt-5 p-2" style="padding-bottom:2.5em">
          <div style="margin-top: 15px;"></div>

          <template v-if="$store.state.user.st_tipo == 'R'">
            <router-view />
            <portal-resultados-solicitante v-if="$router.currentRoute.path == '/' || $router.currentRoute.path == '/resultados'" />
          </template>

          <template v-else>
            <router-view />
            <marcacao-on-line 
              v-if="$router.currentRoute.path == '/' && $store.state.unidade.agendas && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'" 
              :apenas_particular="apenas_particular"
              :nao_marcar_por_outro="portal_configs ? portal_configs.nao_marcar_por_outro : false" />
          </template>

        </div>

        <Toast :baseZIndex="99999" />
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Login from "./components/Login";
import PortalLogin from './components/portal/PortalLogin.vue';
import PortalTopBar from './components/portal/PortalTopBar.vue';
import { mapState } from "vuex";
import MarcacaoOnLine from './components/portal/MarcacaoOnLine.vue';
import PortalResultadosSolicitante from './components/portal/PortalResultadosSolicitante.vue';

export default {
  data() {
    return {
      layoutMode: "overlay",
      layoutColorMode: "light",
      staticMenuInactive: false,
      overlayMenuActive: true,
      mobileMenuActive: false,
      apenas_particular: false,
      link_ajuda: null, 
      portal_configs: {}, 
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods: {
    definir_particular () { 
      this.apenas_particular = true;
    },

    registrar_ajuda (ajuda) { 
      this.link_ajuda = ajuda;
    },

    registrar_configs (configs) { 
      console.log(configs);
      this.portal_configs = _.cloneDeep(configs);
    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    }
  },
  computed: {
    containerClass() {
      return [
        /*"layout-wrapper",*/
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive
        }
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light"
        }
      ];
    },
    logo() {
      return this.layoutColorMode === "dark"
        ? "assets/layout/images/logo-white.svg"
        : "assets/layout/images/logo.svg";
    },
    ...mapState(["user", "isMenuVisible"])
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    Login: Login,
    MarcacaoOnLine,
    PortalLogin, 
    PortalTopBar,
    PortalResultadosSolicitante, 
  }
};

//'AppProfile': AppProfile,
//'AppMenu': AppMenu,
</script>

<style scoped lang="scss">
@import "./App.scss";
.login-wrap {
  height: 100%;
  width: 100%;
}

.vertical-container {
  margin-bottom: 1em;
}

.layout-logo .logo-menu {
  max-width: 200px;
  margin: auto;
}
</style>
